module.exports = __webpack_public_path__ + "img/_1.5947e520.png";